import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

@Injectable()
export class SupplierInvoiceSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "invoiceId";
    }

}
